module.exports = __webpack_public_path__ + "static/img/kaishu_benefit_detail1.a2fc9989.jpg";